import type { EventResponse } from './EventResponse';

export class AnalyticsResponse {
	public success: boolean;
	public statusCode: number;
	public message: string;
	public eventResponseList: EventResponse[];

	constructor(
		success: boolean,
		statusCode: number,
		message: string,
		eventResponseList: EventResponse[],
	) {
		this.success = success;
		this.statusCode = statusCode;
		this.message = message;
		this.eventResponseList = eventResponseList;
	}

	public isSuccess(): boolean {
		return this.success;
	}

	public getStatusCode(): number {
		return this.statusCode;
	}

	public getMessage(): string {
		return this.message;
	}

	public getEventResponseList(): EventResponse[] {
		return this.eventResponseList;
	}
}
